module.exports = "<h1>404</h1>\n<p>Brak strony do wyświetlenia</p>\n"